const observer = new MutationObserver(() => {
  document.querySelectorAll('.bundle-option').forEach((option) => {
    const customSelect = option.querySelector('.custom-select');
    const selectDropdown = option.querySelector('.select-dropdown');
    const hiddenSelect = option.querySelector('select');

    if (customSelect.getAttribute('data-listeners-added') === 'true') return;

    customSelect.setAttribute('data-listeners-added', 'true');

    customSelect.addEventListener('click', () => {
      selectDropdown.style.display = selectDropdown.style.display === 'block' ? 'none' : 'block';
    });

    selectDropdown.addEventListener('click', (event) => {
      const selectedValue = event.target.getAttribute('data-value');
      if (selectedValue) {
        customSelect.querySelector('span').textContent = selectedValue;
        hiddenSelect.value = selectedValue;
        selectDropdown.style.display = 'none';
      }
    });

    document.addEventListener('click', (event) => {
      if (!option.contains(event.target)) {
        selectDropdown.style.display = 'none';
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

$(document).ready(function(){
  if($('#shopify-section-announcement-bar')){
  var announce_height = $('#shopify-section-announcement-bar').height();
  // css('top', $('#text'). outerHeight() + 'px');
  $('.shopify-section.section-header').css('top',announce_height+'px');
  }
  //product page
if($('body').hasClass('template-product')){

  if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) 
{
  $('.product__media-wrapper .slider-mobile-gutter ul.product__media-list li:first .deferred-media__poster').trigger('click');
   // alert("Browser is Safari");  
  document.getElementById('vid').play();
}else{
    // alert("Browser is Not Safari");
  $('.product__media-wrapper .slider-mobile-gutter ul.product__media-list li:first .deferred-media__poster').trigger('click');
  if(navigator.userAgent.search("Chrome") < 0){
  document.getElementById('vid').play();
  }
}
  

  //  var ua = navigator.userAgent.toLowerCase();
  // if (ua.indexOf('safari') != -1) {
  //   if (ua.indexOf('chrome') > -1) {
  //   }
  //   else {
  //     // console.log('hhhh');
  //      // document.getElementById('vid').play();
  //         // Check if video tag exists
  //     // if (jQuery(document).find('.product__media-wrapper .slider-mobile-gutter ul.product__media-list li:first').length > 0) {
  //     //   if (window.location.href.indexOf('reload') == -1) {
  //     //     window.location.replace(window.location.href + '?reload');
  //     //   }
  //     // }
  //   }
  // }

  // $('.thumbnail-slider .thumbnail-list .thumbnail-list__item').each(function(){
  //   $(this).on('click', function(){
  //     alert('hh');
  //     $('.product__media-wrapper .slider-mobile-gutter ul.product__media-list li.is-active .deferred-media__poster').trigger('click');
  //      document.getElementById('vid').play();
  //   });
  // });
}   

  if($('body').hasClass('template-collection')){
    if($('.collection-hero__inner').find('.custom-coll-banner').length <= 0){
      $('.collection-hero__inner').addClass('without_banner');
    }
  }
});


$('.featured-collection-wrapp ul.product-grid').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }  
  ]
});
$('.mobile-toggle svg').on('click', function(){
    $('.multicolumn .multicolumn-list ').toggleClass('show');
  $('.pro-tab-mobile .pro-tab-around .pro-tab-item.after').toggleClass('show');
});
function toggle() {
	var nav = document.querySelector(".custom-sidebar"),
		btn = document.querySelector(".Menu__icon .header__icon");
	nav.classList.toggle("open");
	btn.classList.toggle("is-active");
   $('body').toggleClass('menu_draweropen');
}
function toggle1() {
	var nav = document.querySelector(".custom-search-sidebar"),
		btn = document.querySelector(".Menu__icon .header__icon");
	nav.classList.toggle("open");
	btn.classList.toggle("is-active");
   $('body').toggleClass('search_draweropen');
}
$(".menu-close").click(function() {
    $(".custom-sidebar ").removeClass("open");
  $('body').removeClass('menu_draweropen');
  $('body').removeClass('search_draweropen');
});

// Sidebar 
// $("#nav li a").on("click", function (e) {
// 	//allow links to be followed if they don't have a sub-menu
// 	if ( !$(this).parent().has("ul").length ) { return; }

// 	//we have a sub-menu, so stop the link from being followed
// 	e.preventDefault();

// 	if(!$(this).hasClass("open")) {
// 		//we need to know which 'level' we're on 
// 		var currentLevel = $(this).closest('ul')
// 		$("li ul", currentLevel).slideUp(350);
// 		$("li a", currentLevel).removeClass("open");

// 		// open our new menu and add the open class
// 		$(this).next("ul").slideDown(350);
// 		$(this).addClass("open");
// 	} else {
// 		$(this).removeClass("open");
// 		$(this).next("ul").slideUp(350);
//     }
// });

$("#nav li svg").on("click", function (e) {
	//allow links to be followed if they don't have a sub-menu
	if ( !$(this).parents().has("ul").length ) { return; }

	//we have a sub-menu, so stop the link from being followed
	e.preventDefault();

	if(!$(this).siblings('a').hasClass("open")) {
		//we need to know which 'level' we're on 
		var currentLevel = $(this).closest('ul')
		$("li ul", currentLevel).slideUp(350);
		$("li a", currentLevel).removeClass("open");

		// open our new menu and add the open class
		$(this).parent('.main_link').next("ul").slideDown(350);
		$(this).siblings('a').addClass("open");
	} else {
		$(this).siblings('a').removeClass("open");
		$(this).parent('.main_link').next("ul").slideUp(350);
    }
});

// Product tab

$('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
})

// Scroll to top

 var toTop = $('.footer-block-image img');

  toTop.on('click', function() {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });

const label = document.querySelector('.dropdown__filter-selected')
const options = Array.from(document.querySelectorAll('.dropdown__select-option'))

options.forEach((option) => {
	option.addEventListener('click', () => {
		label.textContent = option.textContent
	})
})

// Close dropdown onclick outside
document.addEventListener('click', (e) => {
	const toggle = document.querySelector('.dropdown__switch')
	const element = e.target

	if (element == toggle) return;

	const isDropdownChild = element.closest('.dropdown__filter')		
	
	if (toggle){
      if (!isDropdownChild) {
        toggle.checked = false
      }
    }
});

 $('.announcement-main').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      arrows:false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000
});

 

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes("en")) {
    const purchaseOptionWrappers = document.querySelectorAll('.shopify_subscriptions_purchase_option_wrapper');

    purchaseOptionWrappers.forEach(wrapper => {
      if (!wrapper.querySelector('input')) {
        const label = wrapper.querySelector('label');
        if (label) {
          label.innerText = 'Subscribe and get a -15% discount';
        }
      }
    });
  }
});



	